[
  { "date": "2023-12-06", "holidayName": "Itsenäisyyspäivä" },
  { "date": "2023-12-24", "holidayName": "Jouluaatto" },
  { "date": "2023-12-25", "holidayName": "Joulupäivä" },
  { "date": "2023-12-26", "holidayName": "Tapaninpäivä" },
  { "date": "2024-01-01", "holidayName": "Uudenvuodenpäivä" },
  { "date": "2024-01-06", "holidayName": "Loppiainen" },
  { "date": "2024-03-29", "holidayName": "Pitkäperjantai" },
  { "date": "2024-03-31", "holidayName": "Pääsiäispäivä" },
  { "date": "2024-04-01", "holidayName": "2. pääsiäispäivä" },
  { "date": "2024-05-01", "holidayName": "Vappu" },
  { "date": "2024-05-09", "holidayName": "Helatorstai" },
  { "date": "2024-05-19", "holidayName": "Helluntaipäivä" },
  { "date": "2024-06-21", "holidayName": "Juhannusaatto" },
  { "date": "2024-06-22", "holidayName": "Juhannuspäivä" },
  { "date": "2024-11-02", "holidayName": "Pyhäinpäivä" },
  { "date": "2024-12-06", "holidayName": "Itsenäisyyspäivä" },
  { "date": "2024-12-24", "holidayName": "Jouluaatto" },
  { "date": "2024-12-25", "holidayName": "Joulupäivä" },
  { "date": "2024-12-26", "holidayName": "Tapaninpäivä" },
  { "date": "2025-01-01", "holidayName": "Uudenvuodenpäivä" },
  { "date": "2025-01-06", "holidayName": "Loppiainen" },
  { "date": "2025-04-18", "holidayName": "Pitkäperjantai" },
  { "date": "2025-04-20", "holidayName": "Pääsiäispäivä" },
  { "date": "2025-04-21", "holidayName": "2. pääsiäispäivä" },
  { "date": "2025-05-01", "holidayName": "Vappu" },
  { "date": "2025-05-29", "holidayName": "Helatorstai" },
  { "date": "2025-06-08", "holidayName": "Helluntaipäivä" },
  { "date": "2025-06-20", "holidayName": "Juhannusaatto" },
  { "date": "2025-06-21", "holidayName": "Juhannuspäivä" },
  { "date": "2025-11-01", "holidayName": "Pyhäinpäivä" },
  { "date": "2025-12-06", "holidayName": "Itsenäisyyspäivä" },
  { "date": "2025-12-24", "holidayName": "Jouluaatto" },
  { "date": "2025-12-25", "holidayName": "Joulupäivä" },
  { "date": "2025-12-26", "holidayName": "Tapaninpäivä" },
  { "date": "2026-01-01", "holidayName": "Uudenvuodenpäivä" },
  { "date": "2026-01-06", "holidayName": "Loppiainen" },
  { "date": "2026-04-03", "holidayName": "Pitkäperjantai" },
  { "date": "2026-04-05", "holidayName": "Pääsiäispäivä" },
  { "date": "2026-04-06", "holidayName": "2. pääsiäispäivä" },
  { "date": "2026-05-01", "holidayName": "Vappu" },
  { "date": "2026-05-14", "holidayName": "Helatorstai" },
  { "date": "2026-05-24", "holidayName": "Helluntaipäivä" },
  { "date": "2026-06-19", "holidayName": "Juhannusaatto" },
  { "date": "2026-06-20", "holidayName": "Juhannuspäivä" },
  { "date": "2026-10-31", "holidayName": "Pyhäinpäivä" },
  { "date": "2026-12-06", "holidayName": "Itsenäisyyspäivä" },
  { "date": "2026-12-24", "holidayName": "Jouluaatto" },
  { "date": "2026-12-25", "holidayName": "Joulupäivä" },
  { "date": "2026-12-26", "holidayName": "Tapaninpäivä" },
  { "date": "2027-01-01", "holidayName": "Uudenvuodenpäivä" },
  { "date": "2027-01-06", "holidayName": "Loppiainen" },
  { "date": "2027-03-26", "holidayName": "Pitkäperjantai" },
  { "date": "2027-03-28", "holidayName": "Pääsiäispäivä" },
  { "date": "2027-03-29", "holidayName": "2. pääsiäispäivä" },
  { "date": "2027-05-01", "holidayName": "Vappu" },
  { "date": "2027-05-06", "holidayName": "Helatorstai" },
  { "date": "2027-05-16", "holidayName": "Helluntaipäivä" },
  { "date": "2027-06-25", "holidayName": "Juhannusaatto" },
  { "date": "2027-06-26", "holidayName": "Juhannuspäivä" },
  { "date": "2027-11-06", "holidayName": "Pyhäinpäivä" },
  { "date": "2027-12-06", "holidayName": "Itsenäisyyspäivä" },
  { "date": "2027-12-24", "holidayName": "Jouluaatto" },
  { "date": "2027-12-25", "holidayName": "Joulupäivä" },
  { "date": "2027-12-26", "holidayName": "Tapaninpäivä" },
  { "date": "2028-01-01", "holidayName": "Uudenvuodenpäivä" },
  { "date": "2028-01-06", "holidayName": "Loppiainen" },
  { "date": "2028-04-14", "holidayName": "Pitkäperjantai" },
  { "date": "2028-04-16", "holidayName": "Pääsiäispäivä" },
  { "date": "2028-04-17", "holidayName": "2. pääsiäispäivä" },
  { "date": "2028-05-01", "holidayName": "Vappu" },
  { "date": "2028-05-25", "holidayName": "Helatorstai" },
  { "date": "2028-06-04", "holidayName": "Helluntaipäivä" },
  { "date": "2028-06-23", "holidayName": "Juhannusaatto" },
  { "date": "2028-06-24", "holidayName": "Juhannuspäivä" },
  { "date": "2028-11-04", "holidayName": "Pyhäinpäivä" },
  { "date": "2028-12-06", "holidayName": "Itsenäisyyspäivä" },
  { "date": "2028-12-24", "holidayName": "Jouluaatto" },
  { "date": "2028-12-25", "holidayName": "Joulupäivä" },
  { "date": "2028-12-26", "holidayName": "Tapaninpäivä" },
  { "date": "2029-01-01", "holidayName": "Uudenvuodenpäivä" },
  { "date": "2029-01-06", "holidayName": "Loppiainen" },
  { "date": "2029-03-30", "holidayName": "Pitkäperjantai" },
  { "date": "2029-04-01", "holidayName": "Pääsiäispäivä" },
  { "date": "2029-04-02", "holidayName": "2. pääsiäispäivä" },
  { "date": "2029-05-01", "holidayName": "Vappu" },
  { "date": "2029-05-10", "holidayName": "Helatorstai" },
  { "date": "2029-05-20", "holidayName": "Helluntaipäivä" },
  { "date": "2029-06-22", "holidayName": "Juhannusaatto" },
  { "date": "2029-06-23", "holidayName": "Juhannuspäivä" },
  { "date": "2029-11-03", "holidayName": "Pyhäinpäivä" },
  { "date": "2029-12-06", "holidayName": "Itsenäisyyspäivä" },
  { "date": "2029-12-24", "holidayName": "Jouluaatto" },
  { "date": "2029-12-25", "holidayName": "Joulupäivä" },
  { "date": "2029-12-26", "holidayName": "Tapaninpäivä" },
  { "date": "2030-01-01", "holidayName": "Uudenvuodenpäivä" },
  { "date": "2030-01-06", "holidayName": "Loppiainen" },
  { "date": "2030-04-19", "holidayName": "Pitkäperjantai" },
  { "date": "2030-04-21", "holidayName": "Pääsiäispäivä" },
  { "date": "2030-04-22", "holidayName": "2. pääsiäispäivä" },
  { "date": "2030-05-01", "holidayName": "Vappu" },
  { "date": "2030-05-30", "holidayName": "Helatorstai" },
  { "date": "2030-06-09", "holidayName": "Helluntaipäivä" },
  { "date": "2030-06-21", "holidayName": "Juhannusaatto" },
  { "date": "2030-06-22", "holidayName": "Juhannuspäivä" },
  { "date": "2030-11-02", "holidayName": "Pyhäinpäivä" },
  { "date": "2030-12-06", "holidayName": "Itsenäisyyspäivä" },
  { "date": "2030-12-24", "holidayName": "Jouluaatto" },
  { "date": "2030-12-25", "holidayName": "Joulupäivä" },
  { "date": "2030-12-26", "holidayName": "Tapaninpäivä" },
  { "date": "2031-01-01", "holidayName": "Uudenvuodenpäivä" },
  { "date": "2031-01-06", "holidayName": "Loppiainen" },
  { "date": "2031-04-11", "holidayName": "Pitkäperjantai" },
  { "date": "2031-04-13", "holidayName": "Pääsiäispäivä" },
  { "date": "2031-04-14", "holidayName": "2. pääsiäispäivä" },
  { "date": "2031-05-01", "holidayName": "Vappu" },
  { "date": "2031-05-22", "holidayName": "Helatorstai" },
  { "date": "2031-06-01", "holidayName": "Helluntaipäivä" },
  { "date": "2031-06-20", "holidayName": "Juhannusaatto" },
  { "date": "2031-06-21", "holidayName": "Juhannuspäivä" },
  { "date": "2031-11-01", "holidayName": "Pyhäinpäivä" },
  { "date": "2031-12-06", "holidayName": "Itsenäisyyspäivä" },
  { "date": "2031-12-24", "holidayName": "Jouluaatto" },
  { "date": "2031-12-25", "holidayName": "Joulupäivä" },
  { "date": "2031-12-26", "holidayName": "Tapaninpäivä" },
  { "date": "2032-01-01", "holidayName": "Uudenvuodenpäivä" },
  { "date": "2032-01-06", "holidayName": "Loppiainen" },
  { "date": "2032-03-26", "holidayName": "Pitkäperjantai" },
  { "date": "2032-03-28", "holidayName": "Pääsiäispäivä" },
  { "date": "2032-03-29", "holidayName": "2. pääsiäispäivä" },
  { "date": "2032-05-01", "holidayName": "Vappu" },
  { "date": "2032-05-06", "holidayName": "Helatorstai" },
  { "date": "2032-05-16", "holidayName": "Helluntaipäivä" },
  { "date": "2032-06-25", "holidayName": "Juhannusaatto" },
  { "date": "2032-06-26", "holidayName": "Juhannuspäivä" },
  { "date": "2032-11-06", "holidayName": "Pyhäinpäivä" },
  { "date": "2032-12-06", "holidayName": "Itsenäisyyspäivä" },
  { "date": "2032-12-24", "holidayName": "Jouluaatto" },
  { "date": "2032-12-25", "holidayName": "Joulupäivä" },
  { "date": "2032-12-26", "holidayName": "Tapaninpäivä" },
  { "date": "2033-01-01", "holidayName": "Uudenvuodenpäivä" },
  { "date": "2033-01-06", "holidayName": "Loppiainen" },
  { "date": "2033-04-15", "holidayName": "Pitkäperjantai" },
  { "date": "2033-04-17", "holidayName": "Pääsiäispäivä" },
  { "date": "2033-04-18", "holidayName": "2. pääsiäispäivä" },
  { "date": "2033-05-01", "holidayName": "Vappu" },
  { "date": "2033-05-26", "holidayName": "Helatorstai" },
  { "date": "2033-06-05", "holidayName": "Helluntaipäivä" },
  { "date": "2033-06-24", "holidayName": "Juhannusaatto" },
  { "date": "2033-06-25", "holidayName": "Juhannuspäivä" },
  { "date": "2033-11-05", "holidayName": "Pyhäinpäivä" }
]
